import type { TelegramContext } from '@/lib/telegram';
import { useSelectedCity } from '@/lib/use-city';
import { TopBar } from '@/components/TopBar';
import { YellowSearchBar } from '@/components/YellowSearchBar';
import { ActivityBanner } from '@/components/ActivityBanner';
import { HomeCarousel } from '@/components/HomeCarousel';
import { CategoryRow } from '@/components/CategoryRow';
import { DiscoverWaterfall } from '@/components/DiscoverWaterfall';
import { BottomNav } from '@/components/BottomNav';

/**
 * Koom GO Mini App — 首页。
 *
 * 编排顺序与设计稿一致（feature/fc3540e9-…jfif）：
 *   1. TopBar           顶部黄色城市 + 一级 nav 条 + Koom GO logo
 *   2. YellowSearchBar  黄色描边搜索 pill
 *   3. ActivityBanner   活动栏（HOME_ACTIVITY placement）
 *   4. CategoryRow groupon 5 列  团购品类入口
 *   5. HomeCarousel     轮播广告位（HOME_CAROUSEL placement）
 *   6. CategoryRow used_market 4 列  二手市场 placeholder
 *   7. DiscoverWaterfall  探店推荐 2 列瀑布流
 *   8. BottomNav        5-tab 底部导航 + 中心凸起 Discover
 *
 * 编排原则：「Yellow 是 wayfinding 信号，不是装饰」（PRODUCT.md §Design Principles 1）。
 * 一屏只允许出现一处饱和黄色（活动栏 OR 主 CTA）—— 实际渲染时 ActivityBanner 与
 * Carousel + CategoryRow 通过滚动节奏分离，不会同屏并排放两块大黄色。
 */
export function HomePage({ ctx: _ctx }: { ctx: TelegramContext }): React.ReactElement {
  const [cityCode] = useSelectedCity();

  return (
    <main className="min-h-screen pb-24">
      <TopBar />

      <div className="px-5 pt-3 space-y-6">
        <YellowSearchBar />

        <ActivityBanner cityCode={cityCode} />

        <CategoryRow kind="groupon" columns={5} />

        <HomeCarousel cityCode={cityCode} />

        <CategoryRow kind="used_market" columns={4} />

        <DiscoverWaterfall cityCode={cityCode} />
      </div>

      <BottomNav />
    </main>
  );
}
